import useQuickDiagnosisDoctor, {
  QuickDiagnosisDoctorQueryParameter,
  QuickDiagnosisDoctorResult,
} from './useQuickDiagnosisDoctor';

export { useQuickDiagnosisDoctor, type QuickDiagnosisDoctorQueryParameter, type QuickDiagnosisDoctorResult };
